import type { QuotaExceededPayload } from "./index";

// Module-level emitter used by the react-query MutationCache error hook —
// that hook runs outside React, so it can't consume the context directly.
// The provider subscribes to this emitter and forwards payloads to `show()`.

type Listener = (payload: QuotaExceededPayload) => void;

let listener: Listener | null = null;

export function emitQuotaExceeded(payload: QuotaExceededPayload): void {
  if (listener) {
    listener(payload);
  }
}

export function subscribeToQuotaExceeded(fn: Listener): () => void {
  listener = fn;
  return () => {
    if (listener === fn) {
      listener = null;
    }
  };
}
